import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useStatusRegisterReducer = () =>
  useSelector((state: ApplicationState) => state.statusRegister);
